import {useState, useEffect} from "react";
import {CHARACTER_INFO, CharacterInfo} from "../assets/constants/characterInfo";
import {getCharacterFromStorage, saveCharacterToStorage} from "../storage";
import {Artist} from "src/utils/artist.utils";

type UseCharacterParams = {
  artist: Artist;
};

export const useCharacter = ({artist}: UseCharacterParams) => {
  const [selectedCharacter, setSelectedCharacter] =
    useState<CharacterInfo | null>(null);

  const getCharactersByArtist = (artist: Artist): CharacterInfo[] => {
    return CHARACTER_INFO[artist] ?? [];
  };

  const isCharacterInArtist = (
    character: CharacterInfo,
    artist: Artist,
  ): boolean => {
    const characters = getCharactersByArtist(artist);
    return characters.some((char) => char.id === character.id);
  };

  useEffect(() => {
    const initializeCharacter = (): void => {
      const storedCharacter = getCharacterFromStorage();
      if (storedCharacter && isCharacterInArtist(storedCharacter, artist)) {
        setSelectedCharacter(storedCharacter);
        return;
      }

      const characters = getCharactersByArtist(artist);
      if (characters.length > 0) {
        setSelectedCharacter(characters[0]);
      }
    };

    initializeCharacter();
  }, [artist]);

  const changeSelectedCharacter = (character: CharacterInfo): CharacterInfo => {
    setSelectedCharacter(character);
    return character;
  };

  const saveCharacter = (): void => {
    if (selectedCharacter) {
      saveCharacterToStorage(selectedCharacter);
    }
  };

  return {
    selectedCharacter,
    getCharactersByArtist,
    changeSelectedCharacter,
    saveCharacter,
  };
};
